import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Typography, TypographyProps } from './typography';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  textProps?: TypographyProps;
}

export const SectionEmptyState: React.FC<Props> = ({
  text,
  containerStyle,
  textProps,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={[styles.container, containerStyle]}>
      <Typography
        color={theme.sk.color.text.tertiary}
        variant="paragraph-base"
        {...textProps}
      >
        {text}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    borderColor: theme.sk.color.border.tertiary,
    borderRadius: 8,
    borderStyle: 'dashed',
    borderWidth: 1.5,
    height: 40,
    justifyContent: 'center',
    margin: 8,
  },
}));
